<template>
    <div>
        <!--在线留言-->
        <OnlineMsg/>

        <a-form :form="managerForm2" layout="inline">
            <a-form-item label="经办人名称">
                <a-input
                        v-decorator="['managerName', ]"
                />
            </a-form-item>
        </a-form>
        <div style="margin-bottom: 20px;">
            <a-button class="butr" @click="searchConfirm" type="primary" style=" margin-top: 16px;">搜索</a-button>
            <a-button class="butr" @click="backConfirm">重置</a-button>
            <a-button class="butr" @click="addConfirm" type="primary">添加</a-button>
        </div>
        <div>
            <a-modal
                    :visible="visible2"
                    :confirm-loading="confirmLoading"
                    @cancel="handleCancel"

            >
                <template slot="footer">
                    <a-button type="primary" @click="handleCancel">关闭</a-button>
                </template>
                <div>
                    <img alt="example" style="width: 100%;height: 300px;margin-bottom: 20px" :src="previewImage2"/>
                    <img alt="example" style="width: 100%;height: 300px" :src="previewImage3"/>
                </div>
            </a-modal>
        </div>
        <div>
        </div>
        <div>
            <a-spin tip="Loading..." :spinning="spinning">
                <a-table
                        bordered
                        :columns="columnsManager"
                        :dataSource="managerList"
                        :pagination="pagination"
                        rowKey="id"
                        @change="changeManger"
                >
                    <template slot="operation" slot-scope="text,record">
                        <a v-if="(record.reversesideofIDphoto != '' && record.frontofIDphotoUrl != '')
                                && (record.reversesideofIDphoto != undefined && record.frontofIDphotoUrl != undefined)
                                && (record.reversesideofIDphoto != null && record.frontofIDphotoUrl != null)"
                           @click="showPhoto(record)">查看身份证照片
                        </a>&nbsp;
                        <a @click="updateManagerPhoto(record)">修改</a>&nbsp;
                        <a type="dashed" @click="deletePhoto(record)">删除</a>
                    </template>
                </a-table>
            </a-spin>
        </div>
        <div>
            <a-drawer
                    title="修改经办人信息"
                    :width="650"
                    @close="onClose3"
                    :visible="visible3"
            >
                <a-form :form="managerForm3">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="经办人姓名">
                                <a-input
                                        v-decorator="['managerName',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入经办人姓名'
                                            }
                                        ]
                                    }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="身份证号码">
                                <a-input
                                        v-decorator="['identificationNumber',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入身份证号码'
                                            },
                                            {
                                                pattern:/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                                                message:'格式不正确请重新输入'
                                            }
                                        ]
                                    }]"

                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="手机号码">
                                <a-input-number

                                        v-decorator="['phone',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入手机号码'
                                            },
                                            {
                                                pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                                                message: '格式不正确请重新输入'
                                            }
                                        ]
                                    }]"
                                        style="width:160px;margin-right: 5px"
                                />
<!--                                <a-button class="code" :disabled="disabled" @click="sendcode(1)">{{buttontext}}
                                </a-button>-->
                                <a-input style="display: none" v-show="false"
                                         v-decorator="['id']"
                                />
                            </a-form-item>
                        </a-col>
<!--                        <a-col :span="12">
                            <a-form-item label="手机验证码">
                                <a-input
                                        v-decorator="[
                                        'code',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写验证码'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>-->
                    </a-row>

                </a-form>
                <a-form :form="photoForm2">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="请选择上传的身份证照片正面(选填)">
                                <div class="clearfix">
                                    <a-upload
                                            name="frontofIDphotoUrl"
                                            :customRequest="customRequest3"
                                            :showUploadList="false"
                                            listType="picture-card"
                                            class="avatar-uploader fl"
                                            :beforeUpload="beforeUpload3"
                                            @change="handleChange3"
                                    >
                                        <img
                                                v-if="imageUrl3"
                                                :src="downPath + imageUrl3"
                                                alt="avatar"
                                                width="100"
                                        />
                                        <div v-else>
                                            <a-icon
                                                    :type="
                                                    loading3 ? 'loading' : 'plus'
                                                "
                                            />
                                            <div class="ant-upload-text">
                                                身份证照片正面
                                            </div>
                                        </div>
                                    </a-upload>
                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="请选择上传的身份证照片反面(选填)">
                                <div class="clearfix">
                                    <a-upload
                                            name="reversesideofIDphoto"
                                            :customRequest="customRequest4"
                                            :showUploadList="false"
                                            listType="picture-card"
                                            class="avatar-uploader fl"
                                            :beforeUpload="beforeUpload4"
                                            @change="handleChange4"
                                    >
                                        <img
                                                v-if="imageUrl4"
                                                :src="downPath + imageUrl4"
                                                alt="avatar"
                                                width="100"
                                        />
                                        <div v-else>
                                            <a-icon
                                                    :type="
                                                    loading4 ? 'loading' : 'plus'
                                                "
                                            />
                                            <div class="ant-upload-text">
                                                身份证照片反面
                                            </div>
                                        </div>
                                    </a-upload>
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <div>
                    <a-button @click="submitManagerForm2" type="primary">提交</a-button>
                </div>
            </a-drawer>
        </div>
        <div>
            <a-drawer
                    title="添加经办人信息"
                    :width="650"
                    @close="onClose"
                    :visible="visible"
            >
                <a-form :form="managerForm">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="经办人姓名">
                                <a-input
                                        v-decorator="['managerName',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入经办人姓名'
                                            }
                                        ]
                                    }]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="身份证号码">
                                <a-input
                                        v-decorator="['identificationNumber',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入身份证号码'
                                            },
                                            {
                                                pattern:/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                                                message:'格式不正确请重新输入'
                                            }
                                        ]
                                    }]"

                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="手机号码">
                                <a-input-number

                                        v-decorator="['phone',{
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入手机号码'
                                            },
                                            {
                                                pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                                                message: '格式不正确请重新输入'
                                            }
                                        ]
                                    }]"
                                        style="width:160px;margin-right: 5px"
                                />
<!--                                <a-button class="code" :disabled="disabled" @click="sendcode(2)">{{buttontext}}
                                </a-button>-->
                            </a-form-item>
                        </a-col>
<!--                        <a-col :span="12">
                            <a-form-item label="手机验证码">
                                <a-input
                                        v-decorator="[
                                        'code',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写验证码'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>-->
                    </a-row>
                </a-form>
                <a-form :form="photoForm">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="请选择上传的身份证照片正面(选填)">
                                <div class="clearfix">
                                    <a-upload
                                            :customRequest="customRequest"
                                            :showUploadList="false"
                                            listType="picture-card"
                                            class="avatar-uploader fl"
                                            :beforeUpload="beforeUpload"
                                            @change="handleChange"
                                            :value="imageUrl"
                                    >
                                        <img
                                                v-if="imageUrl"
                                                :src="downPath + imageUrl"
                                                alt="avatar"
                                                width="100"
                                        />
                                        <div v-else>
                                            <a-icon
                                                    :type="
                                                    loading ? 'loading' : 'plus'
                                                "
                                            />
                                            <div class="ant-upload-text">
                                                身份证照片正面
                                            </div>
                                        </div>
                                    </a-upload>
                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="请选择上传的身份证照片反面(选填)">
                                <div class="clearfix">
                                    <a-upload
                                            :customRequest="customRequest2"
                                            :showUploadList="false"
                                            listType="picture-card"
                                            class="avatar-uploader fl"
                                            :beforeUpload="beforeUpload2"
                                            @change="handleChange2"
                                            :value="imageUrl2"
                                    >
                                        <img
                                                v-if="imageUrl2"
                                                :src="downPath + imageUrl2"
                                                alt="avatar"
                                                width="100"
                                        />
                                        <div v-else>
                                            <a-icon
                                                    :type="
                                                    loading2 ? 'loading' : 'plus'
                                                "
                                            />
                                            <div class="ant-upload-text">
                                                身份证照片反面
                                            </div>
                                        </div>
                                    </a-upload>
                                </div>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <div>
                    <a-button @click="submitManagerForm" type="primary">提交</a-button>
                </div>
            </a-drawer>
        </div>
    </div>
</template>

<script>
    import {
        getManagerList,
        addManager,
        updateManager,
        deleteManager,
        upLoadIdPhoto,
        getManagerByPrimaryKey,
    }
        from "@/api/manager/manager";
    import moment from "moment";
    import {sendcode} from "@/api/user";
    import {uoloadFilesq} from "../../api/http";
    import {mapGetters, mapState} from "vuex";
    import Input from "../../components/form-builder/form-item/input/Input";
    import OnlineMsg from "@/components/onlineMessage/OnlineMessage";

    const columnsManager = [
        {
            title: "序号",
            dataIndex: "index",
            key: "index",
            customRender: (text, record, index) => `${index + 1}`
        },
        {
            title: "经办人姓名",
            dataIndex: "managerName",
            key: "managerName",
        },
        {
            title: "身份证号码",
            dataIndex: "identificationNumber",
            key: "identificationNumber"
        },
        {
            title: "手机号",
            dataIndex: "phone",
            key: "phone"
        },
        {
            title: "创建时间",
            dataIndex: "createDate",
            key: "createDate",
            customRender: (val, row, index) => {
                return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : ''
            },
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: {customRender: "operation"}
        }
    ];

    moment.locale('zh-cn')

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        components: {
            Input,
            // OnlineMsg
        },
        computed: {
            ...mapState(["downPath"]),
            ...mapGetters(["storeAccount"])
        },
        name: "managerManagement",

        data() {
            return {
                columnsManager,
                managerForm: this.$form.createForm(this),
                managerForm2: this.$form.createForm(this),
                photoForm: this.$form.createForm(this),
                managerForm3: this.$form.createForm(this),
                photoForm2: this.$form.createForm(this),
                visible: false,
                visible2: false,
                visible3: false,
                managerList: [],
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                loading: false,
                loading2: false,
                loading3: false,
                loading4: false,
                spinning: false,
                confirmLoading: false,
                imageUrl: "",
                imageUrl2: "",
                imageUrl3: "",
                imageUrl4: "",
                uploadImgUrl: "",
                uploadImgUrl2: "",
                uploadImgUrl3: "",
                uploadImgUrl4: "",
                previewVisible: false,
                previewVisible2: false,
                previewImage: '',
                previewImage2: '',
                previewImage3: '',
                TitleName: '',
                disabled: false,
                buttontext: "发送验证码",
                wait: 60
            }

        },

        beforeRouteEnter(to, from, next) {
            getManagerList(1, null)
                .then((res) => {
                    next((vm) => {
                        if (res.data.success === "TRUE") {
                            vm.managerList = res.data.data.page.list;
                            vm.pagination = {
                                current: res.data.data.page.pageNum,
                                pageSize: res.data.data.page.pageSize,
                                total: res.data.data.page.total
                            };
                        }
                    });
                })
                .catch(() => {
                    next((vm) => {
                        vm.$message.error("服务器出错！请稍后再试!");
                        vm.$Progress.fail();
                    });
                });
        },
        methods: {
            //=============修改表单==============
            customRequest3(files) {
                let formData = new FormData();
                formData.append("file", files.file);
                upLoadIdPhoto(formData).then((res) => {
                    if (res.data.success === "TRUE") {
                        this.uploadImgUrl3 = res.data.data.path;
                        this.$message.success("图片上传成功!");
                        this.imageUrl3 = this.uploadImgUrl3;
                        this.loading = false;
                    }
                })
                    .catch(() => this.$message.error("上传错误，请重新上传"));
            },
            beforeUpload3(file) {
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                if (!isJPG) {
                    this.$message.error("只能上传图片！请重新选择");
                    return false;
                }
                const isLt300k = file.size / 1024;
                if (isLt300k > 2000) {
                    this.$message.error("图片只能小于2Mb!");
                    return false;
                }
                return isJPG && isLt300k;
            },
            handleChange3(info) {
                if (info.file.status === "done") {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
            customRequest4(files) {
                let formData = new FormData();
                formData.append("file", files.file);
                upLoadIdPhoto(formData).then((res) => {
                    if (res.data.success === "TRUE") {
                        this.uploadImgUrl4 = res.data.data.path;
                        this.$message.success("图片上传成功!");
                        this.imageUrl4 = this.uploadImgUrl4;
                        this.loading = false;
                    }
                })
                    .catch(() => this.$message.error("上传错误，请重新上传"));
            },
            beforeUpload4(file) {
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                if (!isJPG) {
                    this.$message.error("只能上传图片！请重新选择");
                    return false;
                }
                const isLt300k = file.size / 1024;
                if (isLt300k > 2000) {
                    this.$message.error("图片只能小于2Mb!");
                    return false;
                }
                return isJPG && isLt300k;
            },
            handleChange4(info) {
                if (info.file.status === "done") {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
            //修改提交
            submitManagerForm2() {
                this.managerForm3.validateFields((err, values) => {
                    if ((this.imageUrl3 == "" && this.imageUrl4 == "") || (this.imageUrl3 != "" && this.imageUrl4 != "")) {
                        if (!err) {
                            values.frontofIDphotoUrl = this.imageUrl3;
                            values.reversesideofIDphoto = this.imageUrl4;
                            updateManager(values).then(resp => {
                                if (resp.data.success === "TRUE") {
                                    this.visible3 = false;
                                    this.managerForm3.resetFields();
                                    this.photoForm2.resetFields();
                                    this.imageUrl3 = '';
                                    this.imageUrl4 = '';
                                    this.$message.success("修改成功!");
                                    this.initList();
                                } else {
                                    this.$message.error(resp.data.message);
                                }
                            }).catch(() => {
                                this.$message.error("服务器异常，请稍后再试！");
                            });
                        }
                    } else if ((this.imageUrl3 != "" || this.imageUrl4 == "") || (this.imageUrl3 == "" || this.imageUrl4 != "")) {
                        this.$message.error("2张身份证照片必须都上传！")
                    }
                })
            },
            //==================================
            handleCancel() {
                this.visible2 = false;
                this.previewImage2 = "";
                this.previewImage3 = "";
            },
            handleCancel2() {
                this.previewVisible2 = false;
            },
            //显示图片
            showPhoto(data) {
                console.log(data)
                this.visible2 = true;
                this.previewImage2 = this.downPath + data.frontofIDphotoUrl;
                this.previewImage3 = this.downPath + data.reversesideofIDphoto;
            },
            addConfirm() {
                this.visible = true;
            },
            onClose() {
                this.visible = false;
                this.photoForm.resetFields();
                this.imageUrl = '';
                this.imageUrl2 = '';
                this.managerForm.resetFields();
            },
            onClose3() {
                this.visible3 = false;
                this.photoForm2.resetFields();
                this.imageUrl3 = '';
                this.imageUrl4 = '';
                this.managerForm3.resetFields();
            },
            backConfirm() {
                this.managerForm2.resetFields();
                this.initList();
            },
            //添加（点击提交）
            submitManagerForm() {
                this.managerForm.validateFields((err, values) => {
                    if ((this.imageUrl == "" && this.imageUrl2 == "") || (this.imageUrl != "" && this.imageUrl2 != "")) {
                        if (!err) {
                            values.frontofIDphotoUrl = this.imageUrl;
                            values.reversesideofIDphoto = this.imageUrl2;
                            console.log(values)
                            addManager(values).then(resp => {
                                if (resp.data.success === "TRUE") {
                                    this.visible = false;
                                    this.managerForm.resetFields();
                                    this.photoForm.resetFields();
                                    this.imageUrl = '';
                                    this.imageUrl2 = '';
                                    this.$message.success("添加成功!");
                                    this.initList();
                                } else {
                                    this.$message.error(resp.data.message);
                                }
                            }).catch(() => {
                                this.$message.error("服务器异常，请稍后再试！");
                            });
                        }
                    } else if ((this.imageUrl == "" || this.imageUrl2 == "") || (this.imageUrl == "" || this.imageUrl2 != "")) {
                        this.$message.error("2张身份证照片必须都上传！")
                    }
                })
            },
            searchConfirm() {
                this.managerForm2.validateFields((err, values) => {
                    if (!err) {
                        getManagerList(null, values.managerName).then(resp => {
                            // console.log(resp.data.data)
                            if (resp.data.success === "TRUE") {
                                this.managerList = resp.data.data.page.list;
                                this.pagination = {
                                    current: resp.data.data.page.pageNum,
                                    pageSize: resp.data.data.page.pageSize,
                                    total: resp.data.data.page.total
                                };
                            }
                        }).catch(() => {
                            this.$message.error("服务器异常，请稍后再试");
                        });
                    }
                })
            },
            updateManagerPhoto(data) {
                this.visible3 = true;
                getManagerByPrimaryKey(data.id).then(resp => {
                    if (resp.data.success === "TRUE") {
                        // console.log(resp.data.data);
                        this.managerForm3.setFieldsValue({
                            identificationNumber: resp.data.data.data.identificationNumber,
                            managerName: resp.data.data.data.managerName,
                            phone: resp.data.data.data.phone,
                            id: resp.data.data.data.id,
                        });
                        // this.photoForm2.setFieldsValue({
                        //     reversesideofIDphoto: resp.data.data.data.reversesideofIDphoto,
                        //     frontofIDphotoUrl: resp.data.data.data.frontofIDphotoUrl
                        // })
                        this.imageUrl3 = resp.data.data.data.reversesideofIDphoto;
                        this.imageUrl4 = resp.data.data.data.frontofIDphotoUrl;
                    }
                })
            },
            deletePhoto(data) {
                console.log(data);
                let self = this;
                this.$confirm({
                    title: '确定要删除这条数据吗？',
                    content: '数据将无法恢复！',
                    okText: 'Yes',
                    okType: 'danger',
                    cancelText: 'No',
                    onOk() {
                        console.log('OK');
                        deleteManager(data.id).then(resp => {
                            if (resp.data.success === "TRUE") {
                                self.$message.success("删除成功！");
                                this.initList();
                            } else {
                                self.$message.error("删除失败，请稍后再尝试！")
                            }
                        }).catch(() => self.$message.error("服务器异常，请稍后再试！"))
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            },
            //上传身份证照片正面
            customRequest(files) {
                let formData = new FormData();
                formData.append("file", files.file);
                upLoadIdPhoto(formData).then((res) => {
                    if (res.data.success === "TRUE") {
                        this.uploadImgUrl = res.data.data.path;
                        this.$message.success("图片上传成功!");
                        this.imageUrl = this.uploadImgUrl;
                        this.loading = false;
                    }
                })
                    .catch(() => this.$message.error("上传错误，请重新上传"));
            },
            //上传身份证照片反面
            customRequest2(files) {
                let formData = new FormData();
                formData.append("file", files.file);
                upLoadIdPhoto(formData)
                    .then((res) => {
                        if (res.data.success === "TRUE") {
                            console.log(res.data.data.path)
                            this.uploadImgUrl2 = res.data.data.path;
                            this.$message.success("图片上传成功!");
                            this.imageUrl2 = this.uploadImgUrl2;
                            this.loading2 = false;
                        }
                    })
                    .catch(() => {
                        this.$message.error("上传错误，请重新上传");
                    });
            },
            beforeUpload(file) {
                console.log(file.type)
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                if (!isJPG) {
                    this.$message.error("只能上传图片!请重新选择");
                    return false;
                }
                const isLt300k = file.size / 1024;
                if (isLt300k > 2000) {
                    this.$message.error("图片只能小于2Mb!");
                    return false;
                }
                return isJPG && isLt300k;
            },
            beforeUpload2(file) {
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                if (!isJPG) {
                    this.$message.error("只能上传图片！请重新选择");
                    return false;
                }
                const isLt300k = file.size / 1024;
                if (isLt300k > 2000) {
                    this.$message.error("图片只能小于2Mb!");
                    return false;
                }
                return isJPG && isLt300k;
            },
            handleChange(info) {
                if (info.file.status === "done") {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
            handleChange2(info) {
                if (info.file.status === "done") {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
            changeManger(page) {
                this.pagination.current = page.current;
                this.initList();
            },
            initList() {
                let self = this;
                this.spinning = true;
                getManagerList(this.pagination.current, null).then(resp => {
                    this.managerList = resp.data.data.page.list;
                    this.pagination = {
                        current: resp.data.data.page.pageNum,
                        pageSize: resp.data.data.page.pageSize,
                        total: resp.data.data.page.total
                    };
                    this.spinning = false;
                }).catch(() => self.$message.error("服务异常，请稍后再试"))
            },
            sendcode(type) {
                let userName = null
                if (type == 1) {
                    userName = this.managerForm3.getFieldValue("phone");
                } else {
                    userName = this.managerForm.getFieldValue("phone");
                }
                if (userName) {
                    sendcode(userName)
                        .then(res => {
                            this.$ajaxAfter(res).then(() => {
                                this.time();
                            });
                        })
                        .catch(() => {
                            this.$message.error("服务器出错！请稍后再试!");
                        });
                } else {
                    this.$message.error("请输入经办人手机号!");
                }


            },
            time() {
                if (this.wait == 0) {
                    this.disabled = false;
                    this.buttontext = "获取验证码";
                    this.wait = 60;
                } else {
                    this.disabled = true;
                    this.buttontext = "重新发送(" + this.wait + ")";
                    this.wait--;
                    setTimeout(() => {
                        this.time()
                    }, 1000)
                }
            }
        },

    }
</script>

<style scoped>
    .butr {
        margin-right: 10px;
    }
</style>
